import type { ApiResponseError } from '~/api/types.gen'

type ErrorCode = ApiResponseError['code']

export const IGNORED_ERRORS = new Set<ErrorCode>(['expired_token', 'limit_avance', 'unauthorized'])
export const AUTH_ERRORS = new Set<ErrorCode>(['expired_token', 'unauthorized'])
